module.exports = __webpack_public_path__ + "img/zichanxinxilogo.4ceb3c0b.png";